"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import TeaserBarWrapper from "~/components/common/teaserbar-eon/teaserbar-wrapper-eon";
import ArrowRight from "~/components/icons/arrow-right-eon";
import { useLanguage } from "~/translations/loader/use-language";
export function SverigeTeaserCard(t0) {
  const $ = _c(17);
  const {
    href,
    imageSrc,
    title,
    hideLinkText
  } = t0;
  const t = useLanguage();
  let t1;
  if ($[0] !== imageSrc || $[1] !== title) {
    t1 = <div className="relative"><CustomImage alt={title} className="aspect-[7/5] w-full object-cover object-top" height={300} sizes="(max-width: 768px) 100vw, 33vw" src={imageSrc} width={400} /></div>;
    $[0] = imageSrc;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== title) {
    t2 = title && <p className="font-medium text-4xl md:text-lg lg:text-xl xl:text-3xl" data-source="lc">{title}</p>;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== hideLinkText || $[6] !== t) {
    t3 = !hideLinkText && <p className="flex items-center gap-x-2 pt-4 text-2xl group-hover:underline md:text-base lg:pt-8 lg:text-xl" data-source="lc"><ArrowRight />{t.teaserbar_linkText}</p>;
    $[5] = hideLinkText;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex flex-grow flex-col justify-between bg-primary p-6 md:p-4 lg:p-6 xl:p-8">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <div className="flex h-full flex-col text-white">{t1}{t4}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== href || $[15] !== t5) {
    t6 = <li><CustomLink blank={true} className="group flex h-full flex-col text-white" href={href}>{t5}</CustomLink></li>;
    $[14] = href;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
export function SverigeTeaserCards() {
  const $ = _c(10);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.sverige_teaser_benefits) {
    t0 = <SverigeTeaserCard href="https://www.eon.se/om-e-on/jobb/formaner" imageSrc="images/teaserbar/sverige/teaser1.webp" title={t.sverige_teaser_benefits} />;
    $[0] = t.sverige_teaser_benefits;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t.sverige_teaser_business) {
    t1 = <SverigeTeaserCard href="https://www.eon.se/om-e-on/om-foeretaget" imageSrc="images/teaserbar/sverige/teaser2.webp" title={t.sverige_teaser_business} />;
    $[2] = t.sverige_teaser_business;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t.sverige_teaser_values) {
    t2 = <SverigeTeaserCard href="https://www.eon.se/om-e-on/jobb" imageSrc="images/teaserbar/sverige/teaser3.webp" title={t.sverige_teaser_values} />;
    $[4] = t.sverige_teaser_values;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
export default function TeaserBarEonSverige() {
  const $ = _c(3);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SverigeTeaserCards />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.teaserbar_header) {
    t1 = <TeaserBarWrapper className="w-full font-bold text-4xl text-primary md:text-right lg:text-5xl" headline={t.teaserbar_header}>{t0}</TeaserBarWrapper>;
    $[1] = t.teaserbar_header;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}